import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError} from "../../../../../../../../logics/api_config";
import {useApiRentriCalls} from "../../../api-hooks/api_rentri_config";
import {
    IRentriCategoriaRaee
} from "../../../../../../../../utils/interfaces/special_wasty/rentri/codifiche/rifiuto/IRentriCategoriaRaee";


const useApiGetRentriCategorieRaee = (): UseQueryResult<IRentriCategoriaRaee[], CustomAxiosError> => {
    const {get} = useApiRentriCalls()

    async function doGet(): Promise<IRentriCategoriaRaee[]> {
        try {
            const response = await get(`/codifiche/v1.0/lookup/categorie-raee`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetRentriCategorieRaee"],
        queryFn: () => doGet(),
    })
};

export default useApiGetRentriCategorieRaee